import { render, staticRenderFns } from "./AddOnForm.vue?vue&type=template&id=3db34c0b&scoped=true"
import script from "./AddOnForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOnForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db34c0b",
  null
  
)

export default component.exports